export const AnalyticsInitializer = {
  init(currentUser, orgName, orgUnitNames) {
    try {
      pendo.initialize({
        visitor: {
          id: currentUser.Email,
          Role: currentUser.SystemRole.DisplayName,
          Orgs: orgName,
          OrgUnits: orgUnitNames
        }
      });
    } catch (error) {
      console.log(error);
    }
  }
};
